import { inject, Injectable } from '@angular/core';
import { EmployeeCreateModel, EmployeeModel, EmployeeRoleModel, EmployeeRoleRefModel } from '@libs/account/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmployeeRepositoryService {
  private readonly connector: ConnectorService = inject(ConnectorService);

  public getDelegatableRoles(): Observable<EmployeeRoleModel[]> {
    return this.connector.connect('employee', 'delegatableRoles', {
    });
  }

  public getEmployees(): Observable<EmployeeModel[] | undefined> {
    return this.connector.connect('employee', 'customerEmployees', {
    });
  }

  public createEmployee(payload: EmployeeCreateModel): Observable<EmployeeModel> {
    return this.connector.connect('employee', 'createCustomerEmployee', {
      payload,
    });
  }

  public getEmployee(id: string): Observable<EmployeeModel> {
    return this.connector.connect('employee', 'employees', {
      pathParams: { id },
    });
  }

  public deleteEmployee(id: string): Observable<void> {
    return this.connector.connect<void>('employee', 'deleteEmployee', {
      pathParams: { id },
    });
  }

  public replaceEmployeeRoles(id: string, roles: EmployeeRoleRefModel[]): Observable<void> {
    return this.connector.connect<void>('employee', 'replaceEmployeeRoles', {
      pathParams: { id },
      payload: roles,
    });
  }

  public renewInvitationEmployee(id: string): Observable<void> {
    return this.connector.connect<void>('employee', 'renewInvitationEmployee', {
      pathParams: { id },
    });
  }
}
